export default function Avatar({ user, src, name = "", size = 32, className = "" }) {
  // Acepta tanto un user object completo como src/name por separado.
  // Header.jsx pasaba user={user}; sen este destructure ignorábase e
  // sempre se mostraba "?" no top-right tras subir foto.
  const finalSrc  = src ?? user?.avatarUrl ?? null;
  const finalName = name || user?.name     || "";

  const initials = finalName
    .split(" ")
    .slice(0, 2)
    .map(w => w[0]?.toUpperCase() ?? "")
    .join("");

  const colors = ["bg-red-400", "bg-orange-400", "bg-yellow-400", "bg-green-500",
                  "bg-blue-500", "bg-indigo-500", "bg-purple-500", "bg-pink-500"];
  const colorClass = colors[(finalName.charCodeAt(0) || 0) % colors.length];

  return finalSrc ? (
    <img
      src={finalSrc}
      alt={finalName}
      className={`rounded-full object-cover ${className}`}
      style={{ width: size, height: size }}
      onError={e => { e.currentTarget.style.display = "none"; }}
    />
  ) : (
    <div
      className={`rounded-full flex items-center justify-center text-white font-semibold ${colorClass} ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
    >
      {initials || "?"}
    </div>
  );
}
